import UserProfilePage from '../../../../../app/UserProfile/UserProfilePage';
import { useMenus } from '../../../MenuProvider';
import ColorMode from '../ColorMode';
import NotificationSection from './NotificationSection';

function UserSection() {
    const { handleColorMode } = useMenus();
    return (
        <div className=" flex flex-row items-center justify-end gap-x-8 w-full">
            <div className="user-section flex flex-row justify-between items-center gap-1 lg:w-32">
                {/* Dark mode  */}
                <ColorMode layout="default" onClick={handleColorMode} />
                <NotificationSection />
                <UserProfilePage />
            </div>
        </div>
    );
}
export default UserSection;
